// Cross-domain URL utilities for HoleScale
// App (app.holescale.com) links to Marketing (holescale.com)

// Auto-detect localhost for development
function getAppUrl(): string {
  // If explicitly set via env var, use that
  if (import.meta.env.VITE_APP_URL) {
    return import.meta.env.VITE_APP_URL;
  }
  
  // Auto-detect localhost in browser
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost' || 
      hostname === '127.0.0.1' ||
      hostname.startsWith('192.168.') ||
      hostname.startsWith('10.0.');
    
    if (isLocalhost) {
      // If we're on the marketing site (port 3000), link to app on port 8080
      // If we're on the app itself, use current host
      const port = window.location.port;
      if (port === '3000' || port === '') {
        // Marketing site - link to app on port 8080
        return `${window.location.protocol}//${hostname}:8080`;
      }
      // App itself - use current host
      return `${window.location.protocol}//${window.location.host}`;
    }
  }
  
  // Default to production
  return 'https://app.holescale.com';
}

// APP_URL: Auto-detects localhost for development, or uses env var, or defaults to production
export const APP_URL = getAppUrl();

// MARKETING_URL: Use environment variable, or default to production
// Note: Marketing site typically runs separately, so we keep it pointing to production
// unless explicitly configured via VITE_MARKETING_URL
// If you have a local marketing site, set VITE_MARKETING_URL=http://localhost:PORT in your .env
export const MARKETING_URL = import.meta.env.VITE_MARKETING_URL || 'https://holescale.com';

// Links to the marketing site (holescale.com)
export const marketingLinks = {
  home: MARKETING_URL,
  blog: `${MARKETING_URL}/blog`,
  pricing: `${MARKETING_URL}/pricing`,
  forSuppliers: `${MARKETING_URL}/for-suppliers`,
  forBuyers: `${MARKETING_URL}/for-buyers`,
  about: `${MARKETING_URL}/about`,
  features: `${MARKETING_URL}/features`,
  howItWorks: `${MARKETING_URL}/how-it-works`,
  contact: `${MARKETING_URL}/contact`,
  faq: `${MARKETING_URL}/faq`,
  resources: `${MARKETING_URL}/resources`,
  glossary: `${MARKETING_URL}/glossary`,
  waitlist: `${MARKETING_URL}/waitlist`,
  investors: `${MARKETING_URL}/investors`,
  privacy: `${MARKETING_URL}/privacy`,
  privacyPolicy: `${MARKETING_URL}/privacy-policy`,
  terms: `${MARKETING_URL}/terms`,
};

// Links within the app (app.holescale.com) - for internal navigation
export const appLinks = {
  login: '/auth',
  signup: '/auth?mode=signup',
  signupSupplier: '/auth?mode=signup&type=supplier',
  signupBuyer: '/auth?mode=signup&type=buyer',
  dashboard: '/dashboard',
  supplierDashboard: '/supplier/dashboard',
  buyerDashboard: '/buyer/dashboard',
  adminDashboard: '/admin/dashboard',
  settings: '/settings',
  messages: '/messages',
  orders: '/orders',
  rfq: '/rfq',
};
